var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNintexIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.24 41.3887C78.16 36.9258 72.5943 34.6973 65.92 34.6973C61.84 34.6973 58.1315 35.4401 55.16 36.5544C52.1943 37.6687 49.9658 39.1601 48.1143 41.3887V35.4401H35.1315V90.103H48.4858V62.5887C48.4858 57.383 49.9715 53.663 52.1943 51.063C54.7886 48.4573 58.5029 46.9715 62.9543 46.9715C67.0343 46.9715 70 48.0858 71.8572 50.3201C74.0858 52.5487 75.1943 55.8973 75.1943 60.7315V90.4801H88.5486V59.2458C88.5486 51.4344 86.32 45.4858 82.24 41.3944V41.3887Z",
    fill: "#814199"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4457 33.7658V94.3487C98.4457 96.6458 96.5829 98.5087 94.2857 98.5087H29.3886C27.0914 98.5087 25.2286 96.6458 25.2286 94.3487V29.4516C25.2286 27.1544 27.0914 25.2916 29.3886 25.2916H89.9714V12.063H22.7771C16.8229 12.063 12 16.8858 12 22.8401V100.96C12 106.909 16.8229 111.737 22.7771 111.737H100.897C106.846 111.737 111.674 106.914 111.674 100.96V33.7658H98.4457Z",
    fill: "#814199"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M111.737 12H98.3828V25.3543H111.737V12Z",
    fill: "#F36E21"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNintexIcon);
export default __webpack_public_path__ + "static/media/nintex-icon.29c427fbe690d07c0c0ff4a3dd6f9814.svg";
export { ForwardRef as ReactComponent };